module.exports = __webpack_public_path__ + "img/img-empresa-tambem-ajuda.56b20a9b.png";